import {MI} from "../init";
import {AbstractSymbol} from "./AbstractSymbol";
import {MadnesTween} from "../libs/mi/MadnesTween";

/**
 * @constructor
 * @extends {AbstractSymbol}
 * @param {number} symbolNum
 * @param {number=} reelX
 * @param {number=} reelY
 * @param {?string=} name
 */
export function SlotSymbol(symbolNum, reelX, reelY, name) {

	if(typeof reelX === 'undefined') { reelX = -1 };
	if(typeof reelY === 'undefined') { reelY = -1 };

	AbstractSymbol.call(this, symbolNum, reelX, reelY, name);

	/** @type {Function} */
	this._winAnimResolver;
	/** @type {MadnesObject} */
	this._multi;
	/** @type {Array} */
	this._multiPosX = [];
	/** @type {Array} */
	this._multiPosY = [];

	/** @type {MadnesObject} */
	this._winSymbol;

	/** @type {MadnesObject} */
	this._winBg;

	/** @type {MadnesObject} */
	this._fireWildBg;

	/** @type {MadnesObject} */
	this._fireStickBg;
	/** @type {MadnesObject} */
	this._fireStickBgLoop;

	/** @type {Arrow} */
	this._arrow;

	/** @type {MadnesTween} */
	this._tweenWildBg;

	/** @type {MadnesTween} */
	this._tweenWinBgAngle;
	/** @type {MadnesTween} */
	this._tweenWinBgScale;

	/** @type {MadnesTween} */
	this._tweenMultiAngle;
	/** @type {MadnesTween} */
	this._tweenMultiScale;
	/** @type {MadnesTween} */
	this._tweenMultiAlpha;

	/** @type {MadnesTween} */
	this._tweenFireStickBgAlpha;

	/** @type {MadnesTween} */
	this._tweenStickBgLoop;
};

SlotSymbol.prototype = Object.create(AbstractSymbol.prototype);
SlotSymbol.prototype.constructor = SlotSymbol;

SlotSymbol.multiPos = [
	[180, 100], [215, 114], [240, 128], [253, 157],
	[252, 190], [242, 216], [222, 235], [188, 243],
	[157, 238], [142, 217], [148, 190], [180, 180]
];

/**
 * @param {number} xy - 0 -> x, 1 -> y
 * @param {number} from
 * @returns {Array}
 */
SlotSymbol.getMultiPositions = function(xy, from) {

	//var s = shift ? shi ft : 0;

	var pos = [];
	for(var i = from; i < SlotSymbol.multiPos.length; i++) {
		pos.push(SlotSymbol.multiPos[i][xy] - 180);
	}

	return pos;
};

/** @param {Arrow} arrow */
SlotSymbol.prototype.setArrow = function(arrow) {
	this._arrow = arrow;
};

/** @returns {Arrow} */
SlotSymbol.prototype.getArrow = function() {
	return this._arrow;
};

//Symbol.translatePos = function(pos) {
//	return pos - 180;
//};

SlotSymbol.prototype.clear = function() {
	this.destroy();
};

/**
 * @param {number} x
 * @param {number} y
 * @override
 * @returns {AbstractSymbol}
 */
SlotSymbol.prototype.init = function(x, y) {
	this.createImg("symbols_all_atlas", x, y);
	return this;
};

/**
 * @override
 * @returns {AbstractSymbol}
 */
SlotSymbol.prototype.createSymbol = function() {

	if(this.getTextureName() !== "symbols_all_atlas") {
		this.setTexture("symbols_all_atlas");
	}

	this.setFrameName(this.symbolName);
	return this;
};

SlotSymbol.prototype.createBlurSymbol = function() {

	if(this.getTextureName() !== "symbols_all_atlas") {
		this.setTexture("symbols_all_atlas");
	}

	this.setFrameName(this.symbolName + "_blur");
	return this;
};

/**
 * @param {boolean=} wild
 * @returns {SlotSymbol}
 */
SlotSymbol.prototype.createWinSymbol = function(wild) {
	var _self = this;

	//this._isWild = !!wild;

	if(this.getTextureName() !== "symbols_all_atlas") {
		this.setTexture("symbols_all_atlas");
	}
	this.setFrameName("none");

	if(wild) {
		this._fireWildBg = MI.addImg(0, 0, "fire_background_atlas");
		this._fireWildBg.createAnims();
		this._fireWildBg.anims.add("fire", MI.generateFrameNames("fire_background_", 0, 19, "", 5));
		this._fireWildBg.setAnchor(0.5, 0.5);
		this._fireWildBg.setScale(2.5, 2.5);
		this._fireWildBg.setVisible(false);
		this.addChild(this._fireWildBg);
	}

	if(this._getShineBg()) {
		this._winBg = MI.addImg(0, 0, this._getShineBg());
		this._winBg.setAnchor(0.5, 0.5);
		this._winBg.setScale(0.5, 0.5);
		this._winBg.setBlend("ADD");
		this.addChild(this._winBg);
	}

	this._winSymbol = MI.addImg(0, 0, this.symbolName + "_atlas");
	this._winSymbol.setAnchor(0.5, 0.5);
	this.addChild(this._winSymbol);

	this._winSymbol.createAnims();
	this._winSymbol.anims.add("win", MI.generateFrameNames(this.symbolName + "_", 0, 49, "", 5));

	this._winSymbol.anims.addOnComplete(function() {
		//_self.destroyWin();

//		_self.setTexture("symbols_all_atlas");
//		_self.setFrameName(_self.symbolName);
		_self._winAnimResolver();
	});

	return this;
};

SlotSymbol.prototype.destroyWin = function() {
	//this._winSymbol.destroy();
	this._fireWildBg && this._fireWildBg.anims.stop();

	if(this._tweenWildBg) {
		this._tweenWildBg.stop();
		this._tweenWildBg = null;
	}

	this._tweenWinBgAngle && this._tweenWinBgAngle.stop();
	this._winBg && this._winBg.destroy();
};

/**
 * @returns {string}
 */
SlotSymbol.prototype._getShineBg = function() {

	switch(this.symbolName) {
		case "symbol_Woman":
			return "shine_woman";
		case "symbol_Viking":
			return "shine_viking";
		case "symbol_Wild":
			return "shine_wild";
		case "symbol_Scatter":
			return "shine_scatter";
		default:
			return "";
	}
};

SlotSymbol.prototype.playWinAnim = function() {

	var _self = this;

	if(this._fireWildBg) {
		this._fireWildBg.setVisible(true);
		this._fireWildBg.anims.loop("fire");
	}

	if(this._winBg) {
		this._tweenWinBgAngle = MI.addTween().to(_self._winBg, { 'angle': 90 }, {
			'duration': 5000
		});
		this._tweenWinBgScale = MI.addTween().to(_self._winBg, { 'x': 1.1, 'y': 1.1 }, {
			'scale': true,
			'duration': 400,
			'callback': function() {
				_self._tweenWinBgScale = MI.addTween().to(_self._winBg, { 'x': 0.5, 'y': 0.5 }, {
					'scale': true,
					'delay': 1000,
					'duration': 400
				});
			}
		});
	}

	return new Promise(function(res) {
		_self._winAnimResolver = res;
		_self._winSymbol.anims.play("win", 25);
	});
};

SlotSymbol.prototype.removeWinAnim = function() {

	if(this._fireWildBg) {
		this._tweenWildBg && this._tweenWildBg.stop();
		this._fireWildBg.anims.stop();
		this._fireWildBg.destroy();
		this._fireWildBg = null;
	}

	if(this._winBg) {
		this._tweenWinBgAngle && this._tweenWinBgAngle.stop();
		this._tweenWinBgScale && this._tweenWinBgScale.stop();
		this._winBg.destroy();
		this._winBg = null;
	}

	if(this._winSymbol) {
		this._winSymbol.anims.stop();
		this._winSymbol.destroy();
		this._winSymbol = null;
	}
};

/**
 * @returns {Promise}
 */
SlotSymbol.prototype.fadeOutWildBg = function() {
	var _self = this;

	return new Promise(function(res) {

		_self._tweenWildBg = MI.addTween().to(_self._fireWildBg, { 'alpha': 0 }, {
			'duration': 200,
			'callback': function() {
				_self.destroyWin();
				//_self._fireWildBg.anims.stop();
				_self._fireWildBg.destroy();
				_self._fireWildBg = null;
				res();
			}
		});
	});
};

/**
 * @param {number} num
 */
SlotSymbol.prototype.createMulti = function(num) {

	this._multiPosX = SlotSymbol.getMultiPositions(0, 0);
	this._multiPosY = SlotSymbol.getMultiPositions(1, 0);

	this._multi = MI.addImg(this._multiPosX.shift(), this._multiPosY.shift(), "multi_atlas").setFrameName("x" + num);
	this._multi.setAnchor(0.5, 0.5);
	this._multi.setVisible(false);
	this.addChild(this._multi);
};

/**
 * @returns {Promise}
 */
SlotSymbol.prototype.playMulti = function() {

	var _self = this;
	var multi = this._multi;

	return new Promise(function(res) {

		multi.setVisible(true);
		multi.setAlpha(0);
		multi.setScale(0.1, 0.1);
		multi.setAngle(-90);

		_self._tweenMultiAngle = MI.addTween().to(multi, { 'x': _self._multiPosX, 'y': _self._multiPosY, 'angle': 10 }, {
			//'delay': 2000,
			'duration': 900,
			'callback': function() {}
		}).catmull();

//		MI.addTween().to(multi, { 'angle': 10 }, {
//			'duration': 900,
//			'callback': function() {}
//		});

		_self._tweenMultiScale = MI.addTween().to(multi, { 'x': 1, 'y': 1 }, {
			'scale': true,
			//'delay': 2000,
			'duration': 700,
			'callback': function() {
				_self._tweenMultiScale = MI.addTween().to(multi, { 'x': 0.8, 'y': 0.8 }, {
					'scale': true,
					'duration': 300,
					'callback': function() {
						_self._tweenMultiScale = MI.addTween().to(multi, { 'x': 1.2, 'y': 1.2 }, {
							'scale': true,
							'duration': 400,
							'easing': MadnesTween.getEasing("quartic_out"),
							'yoyo': true
						});
						_self._tweenMultiScale = MI.addTween().to(multi, { 'alpha': 0 }, {
							'delay': 500,
							'duration': 200,
							'callback': function() {
								//_self.destroyMulti();
								res();
							}
						});
					}
				});
			}
		});

		_self._tweenMultiAlpha = MI.addTween().to(multi, { 'alpha': 1 }, {
			//'delay': 2000,
			'duration': 300
		});
	});

	//var _self = this;
};

/**
 * stops, removes and reinits animations
 * can call during animations
 */
SlotSymbol.prototype.removeMulti = function() {

	this._tweenMultiAngle && this._tweenMultiAngle.stop();
	this._tweenMultiScale && this._tweenMultiScale.stop();
	this._tweenMultiAlpha && this._tweenMultiAlpha.stop();

	this._multi && this.destroyMulti();
};

/**
 * removes animations
 * should be called on animation end
 */
SlotSymbol.prototype.destroyMulti = function() {
	this._multiPosX.length = 0;
	this._multiPosY.length = 0;

	this._multi.destroy();
};

/**
 * @param {boolean=} visible
 */
SlotSymbol.prototype.createStickSymbol = function(visible) {
	var _self = this;

	if(typeof visible === 'undefined') { visible = false; }

	if(this.getTextureName() !== "symbols_all_atlas") {
		this.setTexture("symbols_all_atlas");
	}
	this.setFrameName("none");

	this._fireStickBg = MI.addImg(0, 0, "fire_ring_atlas");
	this._fireStickBg.createAnims();
	this._fireStickBg.anims.add("fire", MI.generateFrameNames("fire_ring_", 0, 54, "", 5));
	this._fireStickBg.setAnchor(0.5, 0.5);
	this._fireStickBg.setScale(2, 2);
	this._fireStickBg.setVisible(false);
	this.addChild(this._fireStickBg);

	this._fireStickBgLoop = MI.addImg(0, 0, "fire_ring_loop_atlas");
	this._fireStickBgLoop.createAnims();
	this._fireStickBgLoop.anims.add("fire", MI.generateFrameNames("fire_ring_loop_", 0, 8, "", 5));
	this._fireStickBgLoop.setAnchor(0.5, 0.5);
	this._fireStickBgLoop.setScale(2, 2);
	this._fireStickBgLoop.setAlpha(0);
	this._fireStickBgLoop.setVisible(false);
	this.addChild(this._fireStickBgLoop);

	this._fireStickBg.anims.addOnComplete(function() {
		//_self._fireStickBgLoop.setVisible(true);

		_self._tweenFireStickBgAlpha = MI.addTween().to(_self._fireStickBg, { 'alpha': 0 }, {
			'duration': 300,
			'callback': function() {
				_self._fireStickBg.destroy();
				_self._fireStickBg = null;
			}
		});

	});

	this._winSymbol = MI.addImg(0, 0, "symbols_all_atlas").setFrameName(this.symbolName);
	this._winSymbol.setAnchor(0.5, 0.5);
	this._winSymbol.setVisible(visible);
	this.addChild(this._winSymbol);
};

//SlotSymbol.prototype.hideArrow = function() {
//	this._arrow.setVisible(false);
//};
//
//SlotSymbol.prototype.showArrow = function() {
//	this._arrow.setVisible(true);
//};

SlotSymbol.prototype.burn = function() {

	this._winSymbol.setVisible(true);

	this._fireStickBg.setVisible(true);
	this._fireStickBg.anims.play("fire");

	this._fireStickBgLoop.anims.loop("fire", 25);
	this._fireStickBgLoop.setAlpha(0);
	this._fireStickBgLoop.setVisible(true);

	this._tweenStickBgLoop = MI.addTween().to(this._fireStickBgLoop, { 'alpha': 1 }, {
		'delay': 1750,
		'duration': 300
	});
};

/**
 * stops, removes and reinits animations
 * can call during animations
 */
SlotSymbol.prototype.removeStick = function() {

	if(this._fireStickBg) {
		this._fireStickBg.anims.stop();
		this._fireStickBg.destroy();
		this._fireStickBg = null;
	}

	if(this._fireStickBgLoop) {
		this._fireStickBgLoop.anims.stop();
		this._fireStickBgLoop.destroy();
		this._fireStickBgLoop = null;
	}

	this._tweenFireStickBgAlpha && this._tweenFireStickBgAlpha.stop();
	this._tweenStickBgLoop && this._tweenStickBgLoop.stop();

	this._winSymbol && this._winSymbol.destroy();
	this._winSymbol = null;

	this._arrow && this._arrow.destroy();
	this._arrow = null;
};

/**
 * removes animations
 * should be called on anim end
 */
SlotSymbol.prototype.destroyStick = function() {
	this._fireStickBgLoop && this._fireStickBgLoop.anims.stop();
	//this._fireStickBgLoop.destroy();

	this._fireStickBg && this._fireStickBg.anims.stop();

	this._arrow && this._arrow.destroy();
	this._arrow = null;

	this.destroy();
};